'use strict';

commonService.$inject = ["$rootScope", "$q", "$log", "config", "$localStorage", "Enums", "$window", "defaultLanguage", "supportedLanguages", "ProductTypes", "DiscountTypes"];
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.commonService = commonService;

var _lodash = require('lodash');

var _lodash2 = _interopRequireDefault(_lodash);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/*@ngInject*/
function commonService($rootScope, $q, $log, config, $localStorage, Enums, $window, defaultLanguage, supportedLanguages, ProductTypes, DiscountTypes /*, gettextCatalog*/) {
    return {
        log: $log,
        config: config,
        setTitle: setTitle,
        toPascalCase: toPascalCase,
        getProductNumberAndPromo: getProductNumberAndPromo,
        enums: {
            existsIdInEnum: existsIdInEnum
        },
        localization: {
            getCurrentLanguage: getCurrentLanguage,
            getDefaultLanguage: getDefaultLanguage,
            isLanguageSupported: isLanguageSupported
        },
        navigationMenu: {
            clearActiveMenu: clearActiveMenu,
            setHomeActive: setHomeActive,
            setDiscountsActive: setDiscountsActive,
            setSellersActive: setSellersActive,
            setBrandsActive: setBrandsActive,
            setProductsActive: setProductsActive,
            setNewsActive: setNewsActive
        },
        serverTypes: {
            getProductType: getProductType,
            getDiscountType: getDiscountType,
            getClientValue: getClientValue
        }
    };

    function setTitle(title) {
        $window.document.title = title;
    }

    function toPascalCase(value) {
        // TO DO : functie mag uiteindelijk gedelete worden, back-end moet ervoor gezorgd worden dat Febelco Product namen omgezet worden naar camelcase
        if (!value) {
            return '';
        }
        return value; //return value.toLowerCase().replace(/\b./g, function(a){ return a.toUpperCase(); } );
    }

    /* Enums */
    function existsIdInEnum(enumeration, id) {
        for (var property in enumeration) {
            if (enumeration.hasOwnProperty(property)) {
                if (enumeration[property].id === id) {
                    return true;
                }
            }
        }

        return false;
    }
    /* End: Enums */

    /* Localization */
    function getCurrentLanguage() {
        return window.localStorage.getItem('language') || getDefaultLanguage();
    }

    function getDefaultLanguage() {
        return defaultLanguage;
    }

    function isLanguageSupported(language) {
        for (var i = 0; i < supportedLanguages.length; i++) {
            var sl = supportedLanguages[i];
            if (language.toUpperCase() === sl.toUpperCase()) {
                return true;
            }
        }

        return false;
    }

    /* End: Localization */

    /* Navigation menu */
    function clearActiveMenu() {
        $rootScope.activeMenu = '';
    }

    function setHomeActive() {
        $rootScope.activeMenu = Enums.navigationMenuItems.home.value;
    }

    function setDiscountsActive() {
        $rootScope.activeMenu = Enums.navigationMenuItems.discounts.value;
    }

    function setSellersActive() {
        $rootScope.activeMenu = Enums.navigationMenuItems.sellers.value;
    }

    function setBrandsActive() {
        $rootScope.activeMenu = Enums.navigationMenuItems.brands.value;
    }

    function setProductsActive() {
        $rootScope.activeMenu = Enums.navigationMenuItems.products.value;
    }

    function setNewsActive() {
        $rootScope.activeMenu = Enums.navigationMenuItems.news.value;
    }

    /* end: Navigation menu */

    /* convert server to client types */
    function getProductType(type) {
        if (type === ProductTypes.single.serverValue) {
            return ProductTypes.single.clientValue;
        } else if (type === ProductTypes.pack.serverValue) {
            return ProductTypes.pack.clientValue;
        } else if (type === ProductTypes.panacee.serverValue) {
            return ProductTypes.panacee.clientValue;
        }
        return type;
    }

    function getDiscountType(type) {
        if (type === DiscountTypes.single.serverValue) {
            return DiscountTypes.single.clientValue;
        } else if (type === DiscountTypes.pack.serverValue) {
            return DiscountTypes.pack.clientValue;
        } else if (type === DiscountTypes.panacee.serverValue) {
            return DiscountTypes.panacee.clientValue;
        }
        return type;
    }

    function getClientValue(types, serverValue) {
        var type = _lodash2.default.find(types, function (i) {
            return i.serverValue === serverValue;
        });
        return type ? type.clientValue : null;
    }
    /* END: convert server to client types */

    function getProductNumberAndPromo(productNumber, promocode) {
        var productNumberIsEmpty = !productNumber || productNumber.length <= 0;
        var promocodeIsEmpty = !promocode || promocode.length <= 0;

        if (productNumberIsEmpty && promocodeIsEmpty) {
            return '';
        }

        var productNumberLabel = 'Product number'; //gettextCatalog.getString('productNumber');
        var promocodeLabel = 'PROMO'; //gettextCatalog.getString('PROMO');

        if (promocodeIsEmpty) {
            return '(' + productNumberLabel + ': ' + productNumber + ')';
        }

        if (productNumberIsEmpty) {
            return '(' + promocodeLabel + ': ' + promocode + ')';
        }

        return '(' + productNumberLabel + ': ' + productNumber + ', ' + promocodeLabel + ': ' + promocode + ')';
    }
}


//////////////////
// WEBPACK FOOTER
// ./common/services/commonService.js
// module id = 806
// module chunks = 0